import accountService from "@/services/account";
import { mapActions } from "vuex";
import pointage from "../../mixins/pointage";

export default {
  data() {
    return {
      isActivated: false,
      reason: "",
      status: "primary",
    };
  },
  mixins: [pointage],
  created() {
    this.updateCreationStatus();
  },
  methods: {
    ...mapActions("auth", {
      exchangeToken: "EXCHANGE_TOKEN",
    }),
    ...mapGetters('supportTechnique', {
      appVersion: 'appVersion'
     }),
    updateCreationStatus() {
      const vue = this;
      const data = {
        token: vue.$route.query.token,
        email: vue.$route.query.email,
      };
      accountService
        .activateAccount(data)
        .then(async (res) => {
          vue.isActivated = res.success;
          vue.reason = res.message;
          vue.status = vue.isActivated ? "success" : "danger";
          if (vue.isActivated) {
            // let user = JSON.parse(localStorage.getItem("user"));
            localStorage.setItem("token", vue.$route.query.token);
            let data = {
                version: this.appVersion,
                os: this.browser
            }
            const user = await vue.exchangeToken(data);
            const pk_ix_adv_account_application_status = user ? user.applicationStatus : undefined;
            let layoutRouteRoutePart = "";
            let pageRoute = "";
            const proAccountRoutePart = "vitalliance";
            if (pk_ix_adv_account_application_status === 8) {
              layoutRouteRoutePart = "/employee";
              pageRoute = "/accueil-adv";
            } else {
              layoutRouteRoutePart = "/candidate";
              pageRoute = "/profil-candidat";
            }
            setTimeout(() => {
              vue.$router.push(
                `${layoutRouteRoutePart}/${proAccountRoutePart}${pageRoute}`
              );
            }, 4000);
          }
        })
        .catch((err) => {
          vue.reason = err;
          vue.status = "danger";
        });
    },
  },
};
